import { Injectable } from '@angular/core'
import { DiscountCodeDialogService } from './dialogs/discount-code-dialog.service'
import {
  GetLosDiscountComplete,
  LosDiscountDialogService,
  LosDiscountService,
  LosDiscountView,
  selectLosDiscountViewById,
} from '@tokeet-frontend/los-discount'
import { select, Store } from '@ngrx/store'
import { catchError, switchMap, take, tap } from 'rxjs/operators'
import {
  DiscountCodeService,
  DiscountCodeView,
  GetDiscountCodeComplete,
  selectDiscountCodeViewById,
} from '@tokeet-frontend/discount-codes'
import { EMPTY, of } from 'rxjs'
import { ActionFailed } from '@tokeet-frontend/utility'
import { environment } from '../../../environments/environment'

@Injectable()
export class DiscountDialogService {
  constructor(
    private discountCodeDialog: DiscountCodeDialogService,
    private losDiscountDialog: LosDiscountDialogService,
    private discountCodeService: DiscountCodeService,
    private losDiscountService: LosDiscountService,
    private store: Store<any>
  ) {}

  open(type: 'lengthofstay' | 'discount_code', id: string) {
    if (type === 'lengthofstay') {
      this.store
        .pipe(
          select(selectLosDiscountViewById, { id }),
          switchMap((item) =>
            item
              ? of(item)
              : this.losDiscountService.get(id).pipe(
                  tap((d) => this.store.dispatch(GetLosDiscountComplete({ item: d }))),
                  catchError((error) => {
                    this.store.dispatch(ActionFailed({ error }))
                    return EMPTY
                  })
                )
          ),
          take(1),
          switchMap((item: LosDiscountView) =>
            this.losDiscountDialog
              .open({
                item,
                primaryBtnClass: 'btn btn-success text-uppercase',
                cancelBtnClass: 'btn btn-cst-danger text-uppercase',
                hasModality: environment.features.losModality,
                articleId: 'k782tt9e6k',
              })
              .afterClosed()
          )
        )
        .subscribe()
    } else {
      this.store
        .pipe(
          select(selectDiscountCodeViewById, { id }),
          switchMap((item) =>
            item
              ? of(item)
              : this.discountCodeService.get(id).pipe(
                  tap((d) => this.store.dispatch(GetDiscountCodeComplete({ item: d }))),
                  catchError((error) => {
                    this.store.dispatch(ActionFailed({ error }))
                    return EMPTY
                  })
                )
          ),
          take(1),
          switchMap((item: DiscountCodeView) => this.discountCodeDialog.open({ item }).afterClosed())
        )
        .subscribe()
    }
  }
}
